import SEO from '../../seo'

const translations = {
    en: {
        title: 'Vanish - Private AI Chat',
        description: 'Chat in secrecy, no tracking or logging',
    },
    fr: {
        title: 'Vanish - Chat IA privé',
        description: 'Discutez en toute discrétion, sans suivi ni journalisation',
    },
    de: {
        title: 'Vanish - Privater KI-Chat',
        description: 'Chatten Sie im Geheimen, ohne Tracking oder Protokollierung',
    },
    nl: {
        title: 'Vanish - Privé AI-chat',
        description: 'Chat in het geheim, zonder tracking of logging',
    },
}

const VanishFavicons = ({languageCode = 'en'}) => {
    const text = translations[languageCode] || translations.en
    return (
        <SEO
            title={text.title}
            description={text.description}
            ogImagePath="https://www.startpage.com/sp/cdn/images/startpage-vanish-favicon.png"
            ogUrl="https://vanish.startpage.com"
            favicons={[
                {
                    rel: `icon`,
                    type: `image/x-icon`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/favicon.ico`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/favicon-16x16.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `32x32`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/favicon-32x32.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `192x192`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/android-chrome-192x192.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `512x512`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/android-chrome-512x512.png`,
                },
                {
                    rel: 'apple-touch-icon',
                    type: `image/png`,
                    sizes: `180x180`,
                    href: `https://www.startpage.com/sp/cdn/images/vanish-promo-2/apple-touch-icon.png`,
                },
            ]}
        />
    )
}

export default VanishFavicons
